import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { ModuleDialogs } from '../../constants/Dialogs';
import PropTypes from 'prop-types';

import Checkbox from 'material-ui/Checkbox';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';

import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';


class ModuleEnrolmentByFilterDialog extends Component {

    componentDidMount() {
        this.onSave = this.onSave.bind(this);
        this.onFilterSelect = this.onFilterSelect.bind(this);
        this.onStatusSelect = this.onStatusSelect.bind(this);
        this.onCheck = this.onCheck.bind(this);
    }

    render() {
        if (this.state.open !== ModuleDialogs.ENROLMENT_BY_FILTER_ADD) { return null; } // guard: dialog not open

        const dialogProps = {
            title:          this.props.title,
            open:           true,
            modal:          false,
            onRequestClose: this.props.onClose,
            actions: [
                <FlatButton key="cancel" label="Cancel" onTouchTap={this.props.onCancel} />,
                <FlatButton key="submit" label="Submit" onTouchTap={this.onSave} disabled={!this.state.draft.filterId || !this.state.draft.status} />
            ]
        };

        let filterList;
        if (!!this.state.draft.filters && this.state.draft.filters.length > 0) {
            filterList = this.state.draft.filters.map( (filter) => (<MenuItem key={filter.id} value={filter.id} primaryText={filter.name} />) );
        }

        let statusList;
        if (!!this.state.draft.statuses && this.state.draft.statuses.length > 0) {
            statusList = this.state.draft.statuses.map( (status) => (<MenuItem key={status.id} value={status.id} primaryText={status.name} />) );
        }

        return (
            <Dialog {...dialogProps} >
                <SelectField
                    value={this.state.draft.filterId}
                    fullWidth={true}
                    floatingLabelText="Filter *"
                    onChange={this.onFilterSelect}
                >
                    {filterList}
                </SelectField>
                <SelectField
                    value={this.state.draft.status}
                    fullWidth={true}
                    floatingLabelText="Status *"
                    onChange={this.onStatusSelect}
                >
                    {statusList}
                </SelectField>
                <Checkbox
                    defaultChecked={this.state.draft.isMandatory}
                    label="Mandatory"
                    onCheck={this.onCheck}
                />
            </Dialog>
        );
    }

    onFilterSelect(event, index, value) {
        if (value !== this.state.draft.filterId) {
            DialogActions.updateDraft('filterId', value);
        }
    }

    onStatusSelect(event, index, value) {
        if (value !== this.state.draft.status) {
            DialogActions.updateDraft('status', value);
        }
    }

    onCheck({target}, value) {
        DialogActions.updateDraft('isMandatory', value);
    }

    onSave() {
        const saved = this.props.onSave(this.state.draft);
        if (saved !== false && !!this.props.closeOnSave) { this.props.onClose(); }
    }
}

ModuleEnrolmentByFilterDialog.getStores = () => ([DialogStore]);
ModuleEnrolmentByFilterDialog.calculateState = (prevState) => {
    const {open, draft} = DialogStore.getState();
    return {
        open,
        draft
    };
};

ModuleEnrolmentByFilterDialog.propTypes = {
    title:      PropTypes.string,
    data:       PropTypes.shape({
        filterId:         PropTypes.number,
        status:         PropTypes.string,
        isAssigned:     PropTypes.bool,
        isMandatory:    PropTypes.bool
    }),
    filterList: PropTypes.arrayOf(
        PropTypes.shape({
            id:     PropTypes.string.isRequired,
            name:   PropTypes.string.isRequired
        })
    ),
    statusList: PropTypes.arrayOf(
        PropTypes.shape({
            id:     PropTypes.string.isRequired,
            name:   PropTypes.string.isRequired
        })
    ),
    onClose:        PropTypes.func,
    onCancel:       PropTypes.func,
    onSave:         PropTypes.func,
    closeOnSave:    PropTypes.bool
};

ModuleEnrolmentByFilterDialog.defaultProps = {
    onClose:        DialogActions.close,
    onCancel:       DialogActions.close,
    onSave:         () => true,
    closeOnSave:    true
};

export default Container.create(ModuleEnrolmentByFilterDialog);
